import { useEffect, useRef, useState } from 'react';

// Restored history is quiet. Only newly completed runs in this mounted study
// pulse, including the final poll that changes the study to completed.
export default function useArrivingTrials(studyId, trials) {
    const previous = useRef(null);
    const [arrivals, setArrivals] = useState(new Map());
    useEffect(() => {
        const completed = new Set(trials.filter((row) => row.status !== 'running').map((row) => row.index));
        const before = previous.current;
        previous.current = { studyId, completed };
        if (before?.studyId !== studyId) { setArrivals(new Map()); return; }
        const fresh = [...completed].filter((index) => !before.completed.has(index));
        if (fresh.length) setArrivals((current) => new Map([...current, ...fresh.map((index) => [index, Date.now() + 1400])]));
    }, [studyId, trials]);
    useEffect(() => {
        if (!arrivals.size) return undefined;
        const timer = setTimeout(() => setArrivals((current) => new Map([...current].filter(([, expiry]) => expiry > Date.now()))),
            Math.max(0, Math.min(...arrivals.values()) - Date.now()));
        return () => clearTimeout(timer);
    }, [arrivals]);
    return arrivals;
}
